export const emptyAdditionalData = {
  apartmentUnit: '',
  companyName: '',
};
